import { Box, Form, Heading, Text } from '@medely/ui-kit';
import React, { useEffect, useState } from 'react';
import { ContentLoader, FixedFooterLayout } from '@mp/components';
import { useMarkets } from '@mp/hooks';
import { ApplicationButtons } from '../../components/ApplicationButtons';
import { MarketsFormFields } from './components/MarketsFormFields';
import { useApplicationMutations } from '../../applicationFlowMutations';
import { useCurrentUserForMarketStep } from './graphql';
import { marketStepSchema } from './schema';

export const MarketsContainer = () => {
  const { isLoading, nextStepWithValues, prevStep } = useApplicationMutations();
  const { currentUser, isLoading: isCurrentUserLoading } = useCurrentUserForMarketStep();

  const [zipCode, setZipCode] = useState<string | null | undefined>();

  useEffect(() => {
    if (Boolean(currentUser?.address_zip)) {
      setZipCode(currentUser?.address_zip);
    }
  }, [currentUser]);

  const { markets, isLoading: isMarketsLoading } = useMarkets({
    zipCode,
  });

  const market_ids = currentUser?.professional?.markets?.map(({ id }) => id) ?? [];

  const isInitialLoading = isCurrentUserLoading || isMarketsLoading;

  const initialValues = { zipCode, market_ids };

  const handleSubmit = (values: { market_ids: number[] }) => {
    return nextStepWithValues({ professional: { market_ids: values.market_ids } });
  };

  return (
    <ContentLoader loading={isInitialLoading}>
      <>
        <Heading size="m" testId="markets-title">
          Per Diem Jobs
        </Heading>
        <Box py={2}>
          <Text size="m" testId="markets-subtitle">
            Where are you interested in working? Select from the markets below to instantly book per
            diem jobs.
          </Text>
        </Box>
        <Form handleSubmit={handleSubmit} schema={marketStepSchema} defaultValues={initialValues}>
          <FixedFooterLayout
            footerContent={
              <ApplicationButtons
                disabled={isInitialLoading || isLoading}
                backClick={() => prevStep()}
                loading={isInitialLoading || isLoading}
              />
            }
          >
            <MarketsFormFields
              initialZipCode={currentUser?.address_zip}
              markets={markets}
              onZipCodeChange={setZipCode}
            />
          </FixedFooterLayout>
        </Form>
      </>
    </ContentLoader>
  );
};
